import { Body, Caption, Icon, useChameleonTheme } from "@petsapp/chameleon";
import { mdiCheck } from "@mdi/js";
import { WellnessPlan } from "../types";

export function EntitlementsList({
  entitlements,
}: {
  entitlements: WellnessPlan["entitlements"];
}) {
  // @ts-ignore
  const { chameleon } = useChameleonTheme();

  return (
    <ul>
      {entitlements.map(({ title, description }) => {
        return (
          <li
            style={{
              display: "flex",
              margin: "1rem 0",
              gap: "0.5rem",
            }}
          >
            <Icon path={mdiCheck} color={chameleon.color.Primary} size={16} />
            <div>
              <Body
                marginBottomSize={0}
                style={{ color: `${chameleon.color.DarkGrey}` }}
              >
                {title}
              </Body>
              {description && (
                <Caption marginBottomSize={0}>{description}</Caption>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
